import Base from '../../_config/base';
// import { toggleClass, setActive } from '../../_config/utils';

class Selectthema extends Base {
  constructor(el) {
    super(el);

    // const optionList = el.querySelectorAll('.select__html options');
    const selectElement = el.querySelector('.select__html');
    const themaField = el.closest('form').querySelector('.formThema');
    const toEmailField = el.closest('form').querySelector('.defaultEmail');
    // const defaultEmail = toEmailField.value ? toEmailField.value : 'default';
    const extraEmails = el.closest('form').querySelectorAll('.extraEmail');

    if (selectElement) {
      selectElement.addEventListener('change', () => {
        const selectedOption = selectElement.options[selectElement.selectedIndex];
        const newEmailValue = [...extraEmails][selectElement.selectedIndex - 1].value;
        toEmailField.value = newEmailValue;
        themaField.value = selectedOption.getAttribute('data-filter');
      });
    }
  }
}

Selectthema.className = 'Selectthema';
export default Selectthema;
